import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = {
  ref: "formContent",
  class: "flex flex-col min-h-screen lg:min-h-0 pt-16 lg:pt-0"
}
const _hoisted_4 = { class: "text-2xl text-gray-700 font-body mb-4 px-4 pt-2 absolute lg:relative top-0 left-0 w-full bg-white lg:bg-opacity-0" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Edit")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Expense ")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SideBar = _resolveComponent("SideBar")
  const _component_Select = _resolveComponent("Select")
  const _component_BankExpenseForm = _resolveComponent("BankExpenseForm")
  const _component_CreditCardExpenseForm = _resolveComponent("CreditCardExpenseForm")
  const _component_IncomeExpenseForm = _resolveComponent("IncomeExpenseForm")
  const _component_MiscellaneousExpenseForm = _resolveComponent("MiscellaneousExpenseForm")
  const _component_VehicleExpenseForm = _resolveComponent("VehicleExpenseForm")
  const _component_CommonExpenseForm = _resolveComponent("CommonExpenseForm")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.hideSidebar)
      ? (_openBlock(), _createBlock("aside", {
          key: 0,
          class: "w-1/4 px-2 bg-gray-100 overflow-auto rounded-l-md hidden lg:block",
          style: `height: ${_ctx.formHeight}px`
        }, [
          _createVNode(_component_SideBar, {
            title: "Categories",
            items: _ctx.categories,
            "item-value": "slug",
            "item-label": "name",
            "selected-item": _ctx.formType,
            "onSet-item": _cache[1] || (_cache[1] = $event => (_ctx.setCategory($event)))
          }, null, 8, ["items", "selected-item"])
        ], 4))
      : _createCommentVNode("", true),
    _createVNode("article", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("h2", _hoisted_4, [
          (_ctx.editMode)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _hoisted_5
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("", true),
          (!_ctx.editMode)
            ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _createTextVNode(" Add " + _toDisplayString(_ctx.selectedTitle), 1 /* TEXT */)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("", true),
          _hoisted_6
        ]),
        (!_ctx.hideSidebar)
          ? _createVNode(_component_Select, {
              key: 0,
              class: "block lg:hidden mx-4 mb-6",
              label: "Categories",
              items: _ctx.categories,
              "item-value": "slug",
              "item-label": "name",
              value: _ctx.formType,
              "onSet-item": _cache[2] || (_cache[2] = $event => (_ctx.setCategory($event)))
            }, null, 8, ["items", "value"])
          : _createCommentVNode("", true),
        (['banks', 'investments'].includes(_ctx.formType))
          ? _createVNode(_component_BankExpenseForm, { key: 1 })
          : (['credit-cards'].includes(_ctx.formType))
            ? _createVNode(_component_CreditCardExpenseForm, { key: 2 })
            : (['incomes'].includes(_ctx.formType))
              ? _createVNode(_component_IncomeExpenseForm, { key: 3 })
              : (['miscellaneous'].includes(_ctx.formType))
                ? _createVNode(_component_MiscellaneousExpenseForm, { key: 4 })
                : (['vehicles'].includes(_ctx.formType))
                  ? _createVNode(_component_VehicleExpenseForm, {
                      key: 5,
                      "onUpdate-category": _cache[3] || (_cache[3] = $event => (_ctx.setCategory('vehicles')))
                    })
                  : _createVNode(_component_CommonExpenseForm, { key: 6 })
      ], 512)
    ])
  ]))
}